import { render, staticRenderFns } from "./CardRecords.vue?vue&type=template&id=c8b03170&scoped=true&"
import script from "./CardRecords.vue?vue&type=script&lang=js&"
export * from "./CardRecords.vue?vue&type=script&lang=js&"
import style0 from "./CardRecords.vue?vue&type=style&index=0&id=c8b03170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b03170",
  null
  
)

export default component.exports